import React from 'react';
import { Menu } from 'antd';
import CustomModal from '../../../components/CustomModal/CustomModal';

const SortModal = ({ visible, onClose, onSort, sortOption }) => {

  const menuItems = [
    { key: "hightolow", label: "High to Low (Deal Amount)" },
    { key: "lowtohigh", label: "Low to High (Deal Amount)" },
    { key: "highlyRec", label: "Highly Recommended" },
    { key: "randomSort", label: "Random Sort" },
  ];

  const handleMenuClick = (e) => {
    onSort(e.key);
    onClose();
  };

  const sortMenu = (
    <Menu
      onClick={handleMenuClick}
      selectedKeys={[sortOption]}
      className="custom-sort-menu"
      items={menuItems}
    />
  );

  return (
    <CustomModal
      title="Sort"
      open={visible}
      centered
      onCancel={onClose}
      className="custom-sort-modal"
      content={sortMenu}
    />
  );
};

export default SortModal;
